import { Component, Input, ElementRef, ViewChild, ChangeDetectorRef, HostListener, ViewChildren, QueryList } from "@angular/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { CvNumberLocalizePipe } from "src/app/reusables/pipes/cv-number-localize.pipe";
import { GameObject, GameType, RankingByLogin } from "../game.models";
import { GenericMetricFormatterPipe } from "src/app/reusables/pipes/generic-metric-formatter.pipe";
import { NavigationService } from 'src/app/navigation/navigation.service';
import { TooltipDirective } from "ngx-bootstrap/tooltip";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import OverlayScrollbars from 'overlayscrollbars';
import { GamesService } from "src/app/gamification/command-center/services/games.service";

@Component({
    selector: 'cxone-game-top-team',
    templateUrl: './cxone-game-top-team.component.html',
    styleUrl: './cxone-game-top-team.component.scss'
})

export class CxoneGameTopTeamComponent {
    @Input() game: GameObject;
    @Input() gameStatus: string;
    @Input() rankingData: RankingByLogin;

    @ViewChild('qualifierText') qualifierText: ElementRef<HTMLElement>;
    @ViewChild('metricText', { static: false }) metricText: ElementRef;
    @ViewChild('tooltip', { static: false }) tooltip!: TooltipDirective;
    @ViewChildren('p') tooltipTopTeamRank!: QueryList<NgbPopover>;
    @ViewChild('rankingTooltip', { static: false }) rankingTooltip!: NgbPopover;

    QualifierIcon: string = "";
    QualifierStatus: boolean = false;
    QualifierValidationLeft: string = "";
    QualifierValidationRight: string = "";
    tooltipValidation = false; 
    hoveringPopover = false;
    value: string = "";
    GameType = GameType;
    isInsidePopover: boolean = false;
    isInsideTrophy: boolean = false;
    iconMap: { [key: string]: string } =
        {
            "completed": `${window['_BaseURI']}/App_Themes/CXone/icons/gamification/games/check.svg#check`,
            "failed": `${window['_BaseURI']}/App_Themes/CXone/icons/gamification/games/fail.svg#fail`
        };
    gs: GamesService = null;
    constructor(
        public changeDetector: ChangeDetectorRef,
        public cvLocalizationService: CVLocalizationService,
        public cvNumberLocalizePipe: CvNumberLocalizePipe,
        public metricFormatter: GenericMetricFormatterPipe,
        public navigationService: NavigationService,
        public gameService: GamesService
    ) {
        this.gs = this.gameService;
     }

    async ngOnInit() {
        await this.loadLocalization();
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection('Games');
        }
        catch {
            console.error('Failed to load localization for Games');
        }
    }

    scrollOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 100,
            theme: "scrollbar-agents"
        }
    };

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("Games", key, defaultValue);
        return baseString;
    }

    getBadgeUsingIndex(game: any, index: number): string {
        let reward = null;
        if (game.TopDogRewards != null) {
            if (game.TopDogRewards.length > index) {
                if (game.TopDogRewards[index].Badge != undefined || game.TopDogRewards[index].Badge != null) {
                    reward = game.TopDogRewards[index].Badge.rewardValue;
                } else {
                    reward = null;
                }
            }
        }
        if (reward == null || reward == 0) return null;
        return "../Admin/ImageResizer.aspx?imgid=" + reward + "&w=24&h=24";
    }

    checkTextTruncation(tooltip: string, type: string) {
        this.tooltipValidation = true;
        switch (type) {
            case 'Q1':
                if (this.metricText) {
                    return this.metricText.nativeElement.scrollWidth != this.metricText.nativeElement.clientWidth ? tooltip : "";
                }
                break;
            case 'Q2':
                if (this.qualifierText) {
                    return this.qualifierText.nativeElement.scrollWidth != this.qualifierText.nativeElement.clientWidth ? tooltip : "";
                }
                break;
            default: this.tooltipValidation = false;
        }
        return "";
    }

    getMetricValue() {
        let conversionType = this.game?.SelectedMetrics[0]?.conversionType;
        let myScore = this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos[0]?.MyScore;
        if (myScore === undefined) {
            myScore = this.rankingData?.gameRewards?.MyRankingObj?.Score;
        }
        if (myScore === undefined || this.gameStatus === 'Upcoming' || this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos?.length == 0 || this.getRankingValue(this.game?.underlyingRule?.GameType) === undefined) {
            return '--';
        }
        return this.getFormattedData(myScore, conversionType);
    }

    getQualifierValidation() {
        this.value = this.game?.Qualifier?.abbrev || "";
        let MetricGroupInfos = this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos;
        const qualifierValue = MetricGroupInfos
            ? MetricGroupInfos[MetricGroupInfos?.length - 1]?.MyMetricValue
            : 0;
        const comparerType = this.game?.QualifierLevels?.comparerType;
        const leftNumber = this.game?.QualifierLevels?.leftNumber;
        const rightNumber = this.game?.QualifierLevels?.rightNumber;
        this.evaluateQualifierStatus(comparerType, leftNumber, qualifierValue, rightNumber);
        this.getQualifierIcon();
        return this.gameStatus !== 'Upcoming' && MetricGroupInfos !== undefined;
    }

    public evaluateQualifierStatus(comparerType: number, leftNumber: number, qualifierValue: any, rightNumber?: number): void {
        let conversionType = this.game?.Qualifier?.conversionType;
        let convertedLeftNumber = this.getFormattedData(leftNumber, conversionType);
        let convertedRightNumber = this.getFormattedData(rightNumber, conversionType);
        switch (comparerType) {
            case 1:
                this.QualifierStatus = (qualifierValue > leftNumber);
                this.QualifierValidationRight = `> ${convertedLeftNumber}`;
                break;
            case 2:
                this.QualifierStatus = (qualifierValue < leftNumber);
                this.QualifierValidationRight = `< ${convertedLeftNumber}`;
                break;
            case 3:
                if (leftNumber < rightNumber) {
                    this.QualifierStatus = (qualifierValue > leftNumber && qualifierValue < rightNumber);
                    this.QualifierValidationLeft = `${convertedLeftNumber} <`;
                    this.QualifierValidationRight = `< ${convertedRightNumber}`;
                } else {
                    this.QualifierStatus = (qualifierValue < leftNumber && qualifierValue > rightNumber);
                    this.QualifierValidationLeft = `${convertedRightNumber} <`;
                    this.QualifierValidationRight = `< ${convertedLeftNumber}`;
                }
                break;
            default:
                break;
        }
    }

    getQualifierIcon() {
        const imageKey = this.QualifierStatus ? "completed" : "failed";
        this.QualifierIcon = this.iconMap[imageKey] || '';
    }

    getFormattedData(value, conversionType): string {
        return this.metricFormatter.transform(value, conversionType);
    }

    getUserName() {
        return this.navigationService.loggedInName;
    }

    getParentGroup() {
        let item = this.rankingData?.gameRewards?.Rankings?.find(item => item.GroupID === this.rankingData?.gameRewards?.MyRankingObj?.MatchingRankLevelID);

        if (item) {
            return item.GroupName;
        } else {
            return "";
        }
    };

    openPopover(popover: NgbPopover): void {
        this.isInsideTrophy = true;
        popover.open();
        return;
    }

    changeInsidePopoverFlag(): void {
        this.isInsideTrophy = false;
        this.isInsidePopover = true;
    }

    leavePopover(popover: NgbPopover): void {
        this.isInsidePopover = false;
        setTimeout(() => {
            if (this.isInsideTrophy === true || (this.isInsideTrophy === false && this.isInsidePopover === false)) {
                popover.close();
                return;
            }
        }, 200);
        return;
    }

    getCurrentValueTopTeam() {
        let item = this.rankingData?.gameRewards?.Rankings?.find(item => item.GroupID === this.rankingData?.gameRewards?.MyRankingObj?.MatchingRankLevelID);
        return item.GroupName + ' - ' + this.getFormattedData(item?.FirstMetricActualScore, this.game?.SelectedMetrics[0]?.conversionType);
    };

    getCurrentValueTopDog() {
        let item = this.rankingData?.gameRewards?.Rankings?.find(item => item?.LoginID === this.navigationService?.loggedInID);
        return item?.GroupName + ' - ' + this.getFormattedData(item?.FirstMetricActualScore, this.game?.SelectedMetrics[0]?.conversionType);
    };

    validateCurrentQualifier() {
        let MetricGroupInfos = this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos;

        if (MetricGroupInfos?.length > 1) {
            const qualifierValue = MetricGroupInfos ? MetricGroupInfos[MetricGroupInfos?.length - 1]?.MyMetricValue : 0;
            return this.gs.isQualified(qualifierValue, this.game, this.rankingData);
        } else {
            return true;
        }
    }

    hideTooltips() {
        if (this.tooltipTopTeamRank) {
            this.tooltipTopTeamRank.forEach(tooltip => tooltip.close());
        }
        
        if (this.rankingTooltip) {
            this.rankingTooltip.close();
        }
    }

    getRankingValue(game: number) {
        if (game === this.GameType?.TopTeam) {
            return this.rankingData?.gameRewards?.Rankings?.find(item => item.GroupID === this.rankingData?.gameRewards?.MyRankingObj?.MatchingRankLevelID);
        }
        return this.rankingData?.gameRewards?.Rankings?.find(item => item.LoginID === this.navigationService.loggedInID);
    }

    get isDivisionValid(): boolean {
        return (this.gameStatus === 'Ongoing' || this.gameStatus === 'Ended') && (this.rankingData?.gameRewards?.MyRankingObj === null || this.rankingData?.gameRewards?.MyRankingObj?.MyRanking > 5 || this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos.length === 0 || !this.validateCurrentQualifier() || this.getRankingValue(this.game?.underlyingRule?.GameType) === undefined || this.rankingData?.gameRewards?.MyRankingObj?.MyRanking > this.game?.TopDogRewards?.length);
    }

    get isRankingValid(): boolean {
        return (this.rankingData?.gameRewards?.MyRankingObj !== null && this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos.length > 0 && this.validateCurrentQualifier() && this.getRankingValue(this.game?.underlyingRule?.GameType) !== undefined) || (this.rankingData?.gameRewards?.MyRankingObj?.MyRanking > this.game?.TopDogRewards?.length && this.getRankingValue(this.game?.underlyingRule?.GameType) !== undefined);
    }

    get isRankingInvalid(): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj === null || this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos.length === 0 || !this.validateCurrentQualifier() || this.getRankingValue(this.game?.underlyingRule?.GameType) === undefined;
    }

    get isPopoverRanking(): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj !== null && this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos.length > 0 && this.validateCurrentQualifier() && this.getRankingValue(this.game?.underlyingRule?.GameType) !== undefined;
    }

    get isPopoverNoRank(): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj === null || this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos.length === 0 || !this.validateCurrentQualifier() || this.getRankingValue(this.game?.underlyingRule?.GameType) === undefined;
    }

    isPlaceValid(index: number): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj?.MyRanking !== (index + 1) || this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos.length === 0 || !this.validateCurrentQualifier() || this.getRankingValue(this.game?.underlyingRule?.GameType) === undefined;
    }

    isPlaceCurrentValid(index: number): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj?.MyRanking === (index + 1) && this.rankingData?.gameRewards?.MyRankingObj?.MetricGroupInfos.length > 0 && this.validateCurrentQualifier() && this.getRankingValue(this.game?.underlyingRule?.GameType) !== undefined;
    }

    get isCoinsAmountValid(): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj?.MyRanking <= 5 && this.rankingData?.gameRewards?.MyRankingObj?.MyRanking <= this.game?.TopDogRewards?.length;
    }

    get isCoinsAmountInvalid(): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj?.MyRanking > 5 || this.rankingData?.gameRewards?.MyRankingObj?.MyRanking > this.game?.TopDogRewards?.length;
    }

    get isBadgesValid(): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj?.Badges.length > 0 && this.rankingData?.gameRewards?.MyRankingObj?.MyRanking <= this.game?.TopDogRewards?.length;
    }

    get isBadgesInvalid(): boolean {
        return this.rankingData?.gameRewards?.MyRankingObj?.Badges.length === 0 || this.rankingData?.gameRewards?.MyRankingObj?.MyRanking > this.game?.TopDogRewards?.length;
    }
}
